import React from 'react';

import Card from '../../components/Card/Card';

import styles from './PastPerformanceDisclaimer.css';

const PastPerformanceDisclaimer = () => (
    <Card>
        <span className="past-performance">
            PAST PERFORMANCE IS NOT A GUARANTEE OF FUTURE RESULTS.
        </span>
        <style jsx>{styles}</style>
    </Card>
);

export default PastPerformanceDisclaimer;
